<div class="tab-content" fusePerfectScrollbar fxLayout="column">
    <div fxLayout="column" fxFlex="50" style="margin-bottom: 20px">
        <div fxLayout="row" fxFlex="50" style="margin-bottom: 20px">
            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario"><b>Conta Investimento BTG</b></span>
                <span>
                    {{ cliente?.numero_xp != null ? cliente?.numero_xp : "SEM CONTA" }}
                </span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Data do Cadastro</span>
                <span>{{ cliente.data_cadastro | date: "dd/MM/yyyy" }}</span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Assessor</span>
                <span>{{ assessor == null ? "SEM ASSESSOR" : codigo_assessor + " - " + assessor }}</span>
            </div>
        </div>

        <div fxLayout="row" fxFlex="50" style="margin-bottom: 20px">
            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">
                    <b>{{ cliente.tipo_pessoa == "PF" ? "CPF" : "CNPJ" }}</b>
                </span>
                <span>
                    {{
                        cliente?.cnpj_cpf != null
                            ? cliente.tipo_pessoa == "PF"
                                ? (cliente?.cnpj_cpf | mask: "000.000.000-00")
                                : (cliente?.cnpj_cpf | mask: "00.000.000/0000-00")
                            : "SEM DOCUMENTO"
                    }}
                </span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Data de Nascimento</span>
                <span>{{ cliente.data_nascimento | date: "dd/MM/yyyy" }}</span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Escritório</span>
                <span>{{ cliente.escritorio == null ? "SEM ESCRITÓRIO" : cliente.escritorio?.nome_fantasia }}</span>
            </div>
        </div>

        <div fxLayout="row" fxFlex="50" style="margin-bottom: 20px">
            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Profissão</span>
                <span>
                    <ng-container *ngIf="cliente.profissao?.nome; else naoInformado">
                        {{ cliente.profissao.nome }}
                    </ng-container>
                </span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Tel | Cel</span>
                <span>{{ cliente.telefone || 'NÃO INFORMADO' }} | {{ cliente.celular || 'NÃO INFORMADO' }}</span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">E-mail</span>
                <span>
                    <ng-container *ngIf="cliente.email; else naoInformado">
                        {{ cliente.email }}
                    </ng-container>
                </span>
            </div>
        </div>

        <div fxLayout="row" fxFlex="50" style="margin-bottom: 20px">
            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Suitability</span>
                <span>
                    <ng-container *ngIf="perfil; else naoInformado">
                        {{ perfil }}
                    </ng-container>
                </span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Saldo Projetado</span>
                <span [ngClass]="{ 'conta-negativa': cliente.saldo < 0 }">
                    <ng-container *ngIf="cliente.saldo != null; else naoInformado">
                        R$ {{ cliente.saldo | number: "1.2-2" }}
                    </ng-container>
                </span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Data Vínculo Corretora</span>
                <span>
                    {{ cliente.data_vinculo_corretora | date: "dd/MM/yyyy" }}
                </span>
            </div>
        </div>

        <div fxLayout="row" fxFlex="50" style="margin-bottom: 20px">
            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">Patrimônio (Prosperidade)</span>
                <span>
                    R$
                    {{
                        cliente?.valor_patrimonio_atual == null ? 0 : (cliente.valor_patrimonio_atual | number: "1.2-2")
                    }}
                </span>
            </div>

            <div fxLayout="column" class="margin-column" fxFlex="30">
                <span class="indicador-usuario">SOW</span>
                <span> {{ cliente.sow == null ? 0 : cliente.sow }} % </span>
            </div>
        </div>
    </div>

    <ng-template #naoInformado>NÃO INFORMADO</ng-template>
</div>
